import React, { Component } from 'react'
import { AUTH_TOKEN } from "../../constants";
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { Container, Nav, Navbar, NavbarBrand } from 'react-bootstrap';
import SideBar from './SideBar';
import { COLORS } from '../../utils/colors';

const HeaderWithLocation = () => {
    const location = useLocation();
    const navigate = useNavigate();

    return <Header location={location} navigate={navigate}/>;
};
  

class Header extends Component {

    render() {
        let isPasswordResetPage = this.props.location != null ? this.props.location.pathname === "/change-password" : false
        
        const authToken = localStorage.getItem(AUTH_TOKEN)
        return (
            <header>
                <Navbar className="nav-bar" expand='lg' style={{backgroundColor: COLORS.primaryColor}} collapseOnSelect>
                    <Container>
                        <NavbarBrand style={{ color: 'white' }} >{isPasswordResetPage || !authToken ? <div></div> : <SideBar/>}</NavbarBrand>
                        <NavbarBrand  style={{ color: 'white' }} >{isPasswordResetPage ? "Marketguru reset password" : "Marketguru Admin Site"}</NavbarBrand>
                        { isPasswordResetPage ? <div></div> : 
                            <Nav className='ms-auto'> 
                            {authToken ? (
                            <Link style={{ color: 'white' }} 
                                to="#"
                                className="ml1 pointer black"
                                onClick={() => {
                                localStorage.removeItem(AUTH_TOKEN)
                                this.props.navigate(`/login`, {replace: true})
                                this.props.navigate(0);
                                }}>
                                logout
                            </Link>
                            ) : (
                            <Link style={{ color: 'white' }}  to="/login" className="ml1 no-underline black">
                                login
                            </Link>
                            )}
                        </Nav>}
                    </Container>
                </Navbar>
            </header>
        )
    }
}

export default HeaderWithLocation;